<delab-ngx-title-page fixedPageTitle="Startseite"></delab-ngx-title-page>

@if (welcomeText$ | async; as welcomeText) {
    <h1 class="mt-8 text-center text-[36px]">{{ welcomeText }}</h1>
}

<div class="background2 relative flex min-h-[80vh] items-center justify-center">
    <img
        src="./assets/img/DEDALUS_NOPAYOFF.png"
        alt="Logo Hintergrund"
        class="pointer-events-none absolute inset-0 m-auto h-full w-full select-none object-contain p-8 opacity-10"
    />
    <div class="z-10 grid grid-cols-1 gap-8">
        @for (row of cardRows$ | async; track $index) {
            <div class="flex h-full justify-center">
                <div class="grid h-full gap-8" [class.grid-cols-1]="row.length === 1" [class.grid-cols-2]="row.length === 2">
                    @for (card of row; track card.title) {
                        <app-page-card-new
                            [cardClass]="DEFAULT_CARD_CLASSES"
                            [iconName]="card.iconName"
                            [title]="card.title"
                            [content]="card.content"
                            [buttons]="card.buttons"
                            (buttonClicked)="onCardButtonClicked($event)"
                        >
                        </app-page-card-new>
                    }
                </div>
            </div>
        }
    </div>
</div>
